import { Mail, MessageCircle } from "lucide-react";
import { LOGO_URL, CONTACT, NAV_LINKS } from "../lib/content";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-400 border-t border-white/10"
    >
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="JAR Smart.Studio"
                className="h-18 w-64"
              />
             </div>
            <p className="mt-5 text-slate-400 max-w-sm leading-relaxed">
              Estudio de desarrollo de soluciones a la medida. Diseñamos, construimos y escalamos
              productos digitales para su empresa.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-orange-400 mb-4">
              Navegación
            </div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="hover:text-orange-400 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-orange-400 mb-4">
              Contacto
            </div>
            <ul className="space-y-3">
              <li>
                <a
                  href={CONTACT.mailto}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Mail size={16} /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <MessageCircle size={16} /> {CONTACT.phoneDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs font-mono text-slate-500">
            © {year} <span className="text-orange-500">{`{JAR}`}</span>Smart<span className="text-orange-500">{`.`}</span>Studio
          </p>
          <p className="text-xs text-slate-500">Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
